import { useEffect, useMemo, useState } from 'react';
import { DBI_TOPCHARTS, getLocale, useDispatch } from 'umi';
import { LANGUAGE_CN } from '@home/_config/config';
import { getFilterTags } from '@intelligence/services/filter';
import { useQueryDefinition } from '@intelligence/hooks/useQueryDefinition';
interface ITagItem {
  tag: string;
  tag_cn: string;
  tag_en: string;
}

const getOptions = (data: ITagItem[], isCn: boolean) =>
  data?.map((item) => ({
    value: item.tag,
    text: isCn ? item.tag_cn : item.tag_en,
    // 添加中文字段用于搜索
    textCN: item.tag_cn,
    // 添加英文字段用于搜索
    textEN: item.tag_en,
  }));

const getLocaleTextMap = (data: ITagItem[], isCn: boolean) => {
  const obj: { [key: string]: string } = {};

  data?.forEach((item) => {
    if (!obj[item.tag]) {
      obj[item.tag] = isCn ? item.tag_cn : item.tag_en;
    }
  });

  return obj;
};

/**
 * 获取 SteamTags、GameMode、GameEngine Tags 相关数据及处理
 *
 * @returns {{ isLoading: any; steamTagOptions: any; gameModeOptions: any; gameEngineOptions: any; gameModeLocalTextMap: any; steamTagsLocalTextMap: any; gameEngineLocaleTextMap: any; }}
 */
function useFilterTagsOptions() {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>();
  const [steamTag, setSteamTag] = useState([]);
  const [gameMode, setGameMode] = useState([]);
  const [gameEngine, setGameEngine] = useState([]);

  const locale = getLocale();
  const isCn = locale === LANGUAGE_CN;

  // 获取全局缓存获取
  const filterTags = useQueryDefinition('filterTags');

  useEffect(() => {
    const getFilterTagsData = async () => {
      setIsLoading(true);
      try {
        // const res = await getFilterTags();
        const { game_mode: gameMode, steam_tag: steamTag, game_engine: gameEngine } = filterTags || {};

        // 字符排序
        steamTag?.sort((a: ITagItem, b: ITagItem) => a?.tag.localeCompare(b?.tag));
        gameMode?.sort((a: ITagItem, b: ITagItem) => a?.tag.localeCompare(b?.tag));
        gameEngine?.sort((a: ITagItem, b: ITagItem) => a?.tag.localeCompare(b?.tag));

        setSteamTag(steamTag);
        setGameMode(gameMode);
        setGameEngine(gameEngine || []);
      } catch (e) {}
      setIsLoading(false);
    };
    getFilterTagsData();
  }, [filterTags]);

  const steamTagOptions = useMemo(() => getOptions(steamTag, isCn), [isCn, steamTag]);

  const gameModeOptions = useMemo(() => getOptions(gameMode, isCn), [isCn, gameMode]);

  const gameEngineOptions = useMemo(() => getOptions(gameEngine, isCn), [isCn, gameEngine]);

  const steamTagsLocalTextMap = useMemo(() => getLocaleTextMap(steamTag, isCn), [isCn, steamTag]);
  const gameModeLocalTextMap = useMemo(() => getLocaleTextMap(gameMode, isCn), [isCn, gameMode]);
  const gameEngineLocaleTextMap = useMemo(() => getLocaleTextMap(gameEngine, isCn), [isCn, gameEngine]);

  useEffect(() => {
    dispatch({
      type: `${DBI_TOPCHARTS}/setSteamTagsLocalTextMap`,
      payload: steamTagsLocalTextMap,
    });
  }, [dispatch, steamTagsLocalTextMap]);

  useEffect(() => {
    dispatch({
      type: `${DBI_TOPCHARTS}/setGameModeLocalTextMap`,
      payload: gameModeLocalTextMap,
    });
  }, [dispatch, gameModeLocalTextMap]);

  useEffect(() => {
    dispatch({
      type: `${DBI_TOPCHARTS}/setGameEngineLocaleTextMap`,
      payload: gameEngineLocaleTextMap,
    });
  }, [dispatch, gameEngineLocaleTextMap]);

  return {
    isLoading,
    steamTagOptions,
    gameModeOptions,
    gameEngineOptions,
    gameModeLocalTextMap,
    steamTagsLocalTextMap,
    gameEngineLocaleTextMap,
  };
}

export default useFilterTagsOptions;
